import React from 'react'
import { Link } from 'react-router'
import PropTypes from 'prop-types'
import SwipeableViews from 'react-swipeable-views'
import './home.scss'
import { api } from 'common/app'
import HeadBanner from '../../components/head-banner/index.js'
import Classify from './components/Classify/index.js'

var sumbitTpye = [];//输入框信息
var sumbit = [];  // 选项信息
var _newObj = {}; // 用户基本信息
var checkbox = [];
class Home extends React.Component {
  constructor (props) {
    super(props)
    this.state = {
      Classify: {
        display: false
      },
      character: {
        text: '基本信息',
        one:'1',
        two:'/ 1',
      },
    //  ajax数据
      data:{},
      question:[],
      userinfo:'',
      updata:{},
      lock:1,
      msg:{
          text:'',
          msgIndex:1
      },
    //   checkit:false,
      link:0,
      provinces:[
            '北京市',
            '上海市',
            '天津市',
            '重庆市',
            '河北省',
            '河南省',
            '山西省',
            '陕西省',
            '内蒙古自治区',
            '辽宁省',
            '吉林省',
            '黑龙江省',
            '江苏省',
            '浙江省',
            '安徽省',
            '江西省',
            '福建省',
            '广东省',
            '山东省',
            '湖南省',
            '四川省',
            '广西壮族自治区',
            '海南省',
            '贵州省',
            '云南省',
            '西藏自治区',
            '甘肃省',
            '青海省',
            '宁夏回族自治区',
            '新疆维吾尔族自治区',
            '新疆生产建设兵团'
      ],
      grades:[
        '二级',
        '三级'
      ],
      secondarys:[
        '甲等',
        '乙等',
        '合格',
        '其他'
      ]
    }
    this.refreshProps = this.refreshProps.bind(this);
  }

//   选中值
  changeVal = (name, event) => {
    var newState = {};
    //
    var arr = name.split("|");
    //
    let typeName = arr[1];

    if (typeName == 'radio') {
        if(event.target.checked){
            const thisIndex = arr[0]
            sumbit[thisIndex] = event.target.value

        }
    }
    //
    if (typeName === 'text') {
        const thisIndex = arr[0]
        sumbit[thisIndex] = event.target.value
    }

    // 判断是不是checkbox
    if (typeName == 'checkbox') {
       const thisIndex = arr[0]

        if (checkbox[thisIndex]) {
            console.log(thisIndex);
             console.log(checkbox[thisIndex]);
        } else {
            checkbox[thisIndex] = [];
        }

        if (event.target.checked) {
            //checkbox.push(event.target.value);
            checkbox[thisIndex].push(event.target.value);
        } else {
            var item = checkbox[thisIndex]
            //console.log(item)
            var value = event.target.value
            //console.log(value)
            item[item.indexOf(value)] = null;
            item.splice(item.indexOf(null), 1);
            //console.log(item);
            checkbox[thisIndex] = item
        }
        //console.log(checkbox);
        let main = checkbox[thisIndex];
        sumbit[thisIndex] = main
    } else {
        newState[typeName] = event.target.value;
    }
    //console.log(sumbit)
    this.setState({
      sumbit:sumbit
    })
  }
// user 个人信息
  updatas = (e) =>{
    this.setState({
        updata: {
            username: this.refs.uname.value,
            mobile: this.refs.mobile.value,
            department: this.refs.office.value,
            email: this.refs.mailbox.value,
            province: this.refs.province.value,
            grade: this.refs.grade.value,
            secondary: this.refs.secondary.value,
            hospital: this.refs.hospital.value,
            number_beds: this.refs.bed.value,
            work_years: this.refs.age.value
        }
    })
  }
//   其他输入框
  tpyeText = (tpyeID,e) =>{
    // const idTpye = parseInt(tpyeID);
    sumbitTpye[tpyeID] = e.target.value
    this.setState({
      sumbitTpye:sumbitTpye
    })
    console.log(sumbitTpye)
  }

  // 接口
  getQuestion = () =>{
    api.question({surveyid:''}).then((res)=>{
      this.setState({
        data:res.data,
        question:res.data.question,
        updata:res.data.userinfo,
        userinfo: res.data.userinfo
      })
      let arr =  res.data.question;
      for(let i = 0;i<arr.length;i++){
        if(arr[i].type=='checkbox'){
            checkbox[arr[i].id] = arr[i].checkit
        }
        if(arr[i].checkit){
            sumbit[arr[i].id] = arr[i].checkit;
        }
         if(arr[i].other){
            sumbitTpye[arr[i].id] = arr[i].other;
        }

      }

    },(err)=>{
      console.log(err)
    })
  }

 alertBorder = () =>{
    this.setState({Classify: {display: true}})
    setTimeout(() => {this.setState({Classify: {display: false}})}, 3000)
 }

//
  valiForm = () =>{
    let object = this.state.updata;
    if (object == undefined) {
        this.alertBorder()
    }else{
        for (var key in object) {
            if (object[key] === '') {
                this.alertBorder()
                return false;
            } else {
                _newObj[key] = object[key]
            }
        }
        return true;
    }
 }
  // 提交
  submitFun = (e) => {
    let is_aswer = this.state.data.is_aswer //为0提交信息,并跳转下一页,1已参与,无法跳页,2已填写,可以跳下一页,无需提交信息
    // if (this.valiForm() !== true) {
    //     return false;
    // }
    // if (sumbit == '') {
    //     this.alertBorder()
    //     return false;
    // }

    // if (sumbitTpye == '') {
    //     this.alertBorder()
    //     return false;
    // }
    if( is_aswer != 2){ //代表可以调到下一页，
         this.setState({
             link: 1
         })
        //请求接口，提交数据到后台保存
        sumbitTpye == '' ? sumbitTpye = '' : sumbitTpye
        api.saveOne({
            updata:this.state.updata,
            submit:sumbit,
            submitType:sumbitTpye,
            surveyid: this.state.data.surveyid
        }).then((res)=>{
            console.log(res)
            if (res.code == 200) {
                console.log(res)
                 this.setState({
                     msg: {
                         text: res.msg,
                         msgIndex: 0
                     }
                })
                this.alertBorder()
                if (res.data.is_next == 1) {
                    window.location.reload()
                    // window.location.href = 'http://client.rup-china.com/icu/wx/#/articleDetails'
                } else {
                    // window.location.reload()
                }
            }else {
                this.setState({
                    msg: {
                        text:res.msg,
                        msgIndex: 1
                    }
                })
                this.alertBorder()
            }
        },(err)=>{
            console.log(err)
        })
    }
    e.preventDefault()
  }
  componentWillReceiveProps(nextprops){
    this.refreshProps(nextprops)
  }
  componentDidMount () {
    //alert('项目正在维护中。。');
    this.refreshProps(this.prop)
    // this.getQuestion()
  }
  refreshProps(prop){
    this.getQuestion()
  }
  render () {
    const showClassify = () => {
      if (this.state.Classify.display) {
        return <Classify msg={this.state.msg}/>
      } else {
        return <div/>
      }
    }
     let provinces = this.state.provinces
     let grades = this.state.grades
     let secondarys = this.state.secondarys
     //let provinces = this.state.provinces
    return (<div className='home'>
      <HeadBanner character={this.state.character} />
      <div className='user-message'>
        <label className='user-message-box'>
          <p>你的姓名</p>
          <input ref='uname' type='text'  onChange={this.updatas} placeholder = {this.state.userinfo.username}/>
        </label>
        <label className='user-message-box'>
          <p>手机号码</p>
          <input ref='mobile' type='tel' onChange={this.updatas} placeholder = {this.state.userinfo.mobile}/>
        </label>
        <label className='user-message-box'>
          <p>邮件地址</p>
          <input ref='mailbox' type='text' onChange={this.updatas} placeholder = {this.state.userinfo.email}/>
        </label>
          <label className='user-message-box'>
            <p>省(自治区/直辖市)</p>
            <select ref='province' defaultValue='' value={this.state.userinfo.province} onChange={this.updatas}>
                    <option key='province0' value="">请选择</option>
                    {provinces.length > 0 && provinces.map((item, i) => {
                        return <option key={'province'+i} value={item}>{item}</option>
                    })}
            </select>
        </label>
        <label className='user-message-box'>
            <p>医院等级</p>
            <select ref='grade' defaultValue='' value={this.state.userinfo.grade} onChange={this.updatas}>
                    <option key='grade0' value="">请选择</option>
                    {grades.length > 0 && grades.map((item, i) => {
                        return <option key={'grade'+i} value={item}>{item}</option>
                    })}
            </select>
        </label>
        <label className='user-message-box'>
            <p>医院等次</p>
            <select ref='secondary' defaultValue='' value={this.state.userinfo.secondary} onChange={this.updatas}>
                    <option key='secondary0' value="">请选择</option>
                    {secondarys.length > 0 && secondarys.map((item, i) => {
                        return <option key={'secondary'+i} value={item}>{item}</option>
                    })}
            </select>
        </label>
        <label className='user-message-box'>
          <p>医院名称</p>
          <input ref='hospital' type='text' onChange={this.updatas} placeholder = {this.state.userinfo.hospital}/>
        </label>
        <label className='user-message-box'>
          <p>医院总床位数</p>
          <input ref='bed' type='text' onChange={this.updatas} placeholder = {this.state.userinfo.number_beds}/>
        </label>
        <label className='user-message-box'>
          <p>您的科室</p>
          <input ref='office' type='text' onChange={this.updatas} placeholder = {this.state.userinfo.department}/>
        </label>
        <label className='user-message-box'>
          <p>您的工作年限</p>
          <input ref='age' type='text' onChange={this.updatas} placeholder = {this.state.userinfo.work_years}/>
        </label>
      </div>
      <div className='user-survey'>
          { this.state.question.map((v,i)=>{
              {/* 定义什么属性 */}
              const keyTpye = v.type;
              {/* 问题id */}
              const topieId = v.id
              const contents = v.id + "|" + v.type
              const checkit = v.checkit
              const other = v.other
              {/* 判断是否类型 */}
              if (v.type == 'text') {
                  return <div key={i} className='user-messages'>
                      <label className='user-message-box'>
                          <p>{v.title}</p>
                          <input type={v.type} defaultValue={checkit} readOnly={this.state.lock == 1 ? '':'readOnly'} onChange={this.changeVal.bind(this,contents)}/>
                      </label>
                  </div>
              }
              const listCheck = () => {
                  const object = v.check
                  let check = []
                  if(this.state.data.is_aswer != 0){
                    for (var key in object) {
                      let checks = ''
                      checks = <label key={key} className='user-message-box' >
                          <input ref = {'radio' + topieId} defaultValue = {key} defaultChecked={object[key].checkit == 1 ? true : false} type = {keyTpye} name = {topieId} onChange = {this.changeVal.bind(this,contents)}/>
                          <span>{key} . {object[key].title}</span>
                          <input onChange={this.tpyeText.bind(this,topieId)} defaultValue={other} className='user-input-box' style={{display:object[key].other == 1 ? 'block':'none'}} type='text'/>
                      </label>
                      check.push(checks);
                    }
                  }else{
                    for (var key in object) {
                      let checks = ''
                      checks = <label key={key} className='user-message-box' >
                          <input ref = {'radio' + topieId} defaultValue = {key}  type = {keyTpye} name = {topieId} onChange = {this.changeVal.bind(this,contents)}/>
                          <span>{key} . {object[key].title}</span>
                          <input onChange={this.tpyeText.bind(this,topieId)} defaultValue={other} className='user-input-box' style={{display:object[key].other == 1 ? 'block':'none'}} type='text'/>
                      </label>
                      check.push(checks);
                    }
                  }

                  return (check)
              }
              return <div key={i} className='user-subject'>
                      <p className='user-topic'>{v.title}</p>
                      {listCheck()}
              </div>
          })}
      </div>
      <div className='user-bottom-box'>
            <button style={{backgroundColor:this.state.data.is_aswer == 2 ? '#cccccc':''}} className='user-bottom-button' onClick={this.submitFun}> {this.state.data.is_aswer == 2 ? '已参与' : '提交'} </button>
      </div>
      {showClassify()}
    </div>)
  }
}

export default Home



// WEBPACK FOOTER //
// ./src/routes/home/index.js